/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import styled from 'styled-components';
import styles from '../../styles';

export const Wrapper = styled.div`
  @media (min-width: 1024px) {
    padding-left: 15rem;
  }

`;

export const ProductsBody = styled.div`
  position: relative;
  width: 100%;
  min-height: 12rem;
`;

export const Pane = styled.div`
  height: 100%;
  min-height: 500px;
  margin-bottom: 1rem;
  margin: 0.75rem;
  padding-bottom: 1rem;
  @media (max-width: 767px) {
    margin: 0.75rem 0 0 0;
  }

  @media (max-width: 767px) {
    border-radius: 0;
  }
`;
